import { useContext } from "react";
import { MyContext } from "../App";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const frontend = [
  {
    id: 1,
    skill: "HTML CSS",
  },
  {
    id: 2,
    skill: "Bootstrap",
  },
  {
    id: 3,
    skill: "Tailwind CSS",
  },
  {
    id: 4,
    skill: "JavaScript(ES6)",
  },
  {
    id: 5,
    skill: "JQuery",
  },
  {
    id: 6,
    skill: "React.js",
  },
  {
    id: 7,
    skill: "React Native",
  },
];

const backend = [
  {
    id: 1,
    skill: "language C",
  },
  {
    id: 2,
    skill: "Php",
  },
  {
    id: 3,
    skill: "Laravel",
  },
  {
    id: 4,
    skill: "Python",
  },
  {
    id: 5,
    skill: "Flask",
  },
  {
    id: 6,
    skill: "Node.js Express",
  },
];

const database = [
  {
    id: 9,
    skill: "Sql - MySql",
  },
  {
    id: 10,
    skill: "Mongodb",
  },
];

const ToolsAndMethodologies = [
  {
    id: 11,
    skill: "Git - Github",
  },
  {
    id: 12,
    skill: "Agile Methodology",
  },
];


const Skills = () => {
  const { Lang } = useContext(MyContext);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div id='skills' ref={ref} className="py-12 px-6 md:px-20 bg-gradient-to-b from-black/80 to-black/90 border-t border-white/10 overflow-hidden" >
      <div className="flex flex-col md:flex-row gap-2 md:gap-14 md:items-center">
        <motion.div initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : { x: -100, opacity: 0 }}
          transition={{ duration: 0.2, delay: 0.2 }} className="text-sm italic font-medium uppercase text-white/70 whitespace-nowrap">
          {Lang === 'Ar' ? 'مهاراتي' : (Lang === 'Fr' ? 'MES COMPÉTENCES' : 'MY SKILLS')}
        </motion.div>
        <motion.div initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.3, delay: 0.3 }} className="text-md md:text-2xl italic font-medium uppercase text-white/90 md:pr-8">
          {Lang === 'Ar' ? ".بعد عرض أعمالي المميزة لكم، ربما لاحظتم أنني عملت بعدة أدوار. الآن، دعوني أظهر لكم المهارات التي أمتلكها"
            : (Lang === 'Fr' ? "Après avoir présenté mes œuvres en vedette, vous avez probablement remarqué que j'ai travaillé avec de nombreux rôles. Laissez-moi maintenant vous montrer les compétences que je possède."
              : "After showcasing my featured works, you've likely observed my versatility across various roles. Now, allow me to highlight the skills I possess.")}
        </motion.div>
      </div>
      <div className="py-10 md:py-16 flex flex-col gap-10 md:gap-24">
        <div className="flex flex-col md:flex-row gap-10 md:gap-24">
          <motion.div initial={{ scale: 0, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
            transition={{ ease: "linear", delay: 0.5 }} className="w-full md:w-4/5">
            <img src="https://drive.google.com/thumbnail?id=1n4iFkojJoduV6p3cmI6ZXSF51kj35EfT&sz=w1000" alt="FrontEnd" className="w-full h-[20vh] md:h-[35vh] object-cover rounded grayscale hover:grayscale-0 transition-all duration-700 " loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"} />
            <div className="mt-2 py-3 text-md italic font-bold text-white/70 border-b border-white/10">
              01
            </div>
            <div className="py-3 text-lg md:text-3xl italic font-bold uppercase text-white CosiAzureFont">
              {Lang === 'Ar' ? 'الواجهات الأمامية' : (Lang === 'Fr' ? ' Partie client' : 'Front-End')}
            </div>
            <span className="flex flex-wrap gap-3 text-cyan-400 md:gap-4">
              {frontend.map((tool) => (
                <span key={tool.id} className="hover:underline underline-offset-4 uppercase">{tool.skill}</span>
              ))}
            </span>
          </motion.div>
          <motion.div initial={{ scale: 0, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
            transition={{ ease: "linear", delay: 0.8 }} className="w-full md:w-3/5">
            <img src="https://drive.google.com/thumbnail?id=10BOzzJQBrLEpx0YZcDeQl03vf1-dY9AO&sz=w1000" alt="BackEnd" className="w-full h-[20vh] md:h-[25vh] object-cover rounded grayscale hover:grayscale-0 transition-all duration-700 " loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"} />
            <div className="mt-2 py-3 text-md italic font-bold text-white/70 border-b border-white/10">
              02
            </div>
            <div className="py-3 text-lg md:text-3xl italic font-bold uppercase text-white CosiAzureFont">
              {Lang === 'Ar' ? 'الواجهات الخلفي' : (Lang === 'Fr' ? 'Partie logique' : 'Back-End')}
            </div>
            <span className="flex flex-wrap gap-3 text-cyan-400 md:gap-4">
              {backend.map((tool, i) => (
                <span key={i} className="hover:underline underline-offset-4 uppercase">{tool.skill}</span>
              ))}
            </span>
          </motion.div>
        </div>
        <div className="flex flex-col md:flex-row gap-10 md:gap-24">
          <motion.div initial={{ scale: 0, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
            transition={{ ease: "linear", delay: 1.1 }} className="w-full md:w-3/5">
            <img src="https://drive.google.com/thumbnail?id=1eUGz7HjocevAr0Nz3OIDW2_lhmqqTo28&sz=w1000" alt="Database" className="w-full h-[20vh] md:h-[25vh] object-cover rounded grayscale hover:grayscale-0 transition-all duration-700 " loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"} />
            <div className="mt-2 py-3 text-md italic font-bold text-white/70 border-b border-white/10">
              03
            </div>
            <div className="py-3 text-lg md:text-3xl italic font-bold uppercase text-white CosiAzureFont">
              {Lang === 'Ar' ? 'قاعدة البيانات' : (Lang === 'Fr' ? 'Base de données' : 'Database')}

            </div>
            <span className="flex flex-wrap gap-3 text-cyan-400 md:gap-4">
              {database.map((tool) => (
                <span key={tool.id} className="hover:underline underline-offset-4 uppercase">{tool.skill}</span>
              ))}
            </span>
          </motion.div>
          <motion.div initial={{ scale: 0, opacity: 0 }}
            animate={inView ? { scale: 1, opacity: 1 } : { scale: 0, opacity: 0 }}
            transition={{ ease: "linear", delay: 1.4 }} className="w-full md:w-4/5">
            <img src="https://drive.google.com/thumbnail?id=15cDAPsqmTfA_-h2H-OQf4EmnEwaAiIsb&sz=w1000" alt="Tools" className="w-full h-[20vh] md:h-[35vh] object-cover rounded grayscale hover:grayscale-0 transition-all duration-700 " loading="lazy" onError={(e) => e.target.src = "/assets/images/default.png"} />
            <div className="mt-2 py-3 text-md italic font-bold text-white/70 border-b border-white/10">
              04
            </div>
            <div className="py-3 text-lg md:text-3xl italic font-bold uppercase text-white CosiAzureFont">
              {Lang === 'Ar' ? 'الأدوات والمنهجيات' : (Lang === 'Fr' ? 'Outils et Méthodologies' : 'Tools And Methodologies')}
            </div>
            <span className="flex flex-wrap gap-3 text-cyan-400 md:gap-4">
              {ToolsAndMethodologies.map((tool, i) => (
                <span key={i} className="hover:underline underline-offset-4 uppercase">{tool.skill}</span>
              ))}
            </span>
          </motion.div>
        </div>
      </div>

    </div>
  );
};

export default Skills;
